import API from '@/api/api.js'
import Moment from 'moment';
import Qs from 'qs'

export default class CrmAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  createLead(param, success, error) {
    this.api.post('/crm/lead/create', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }

  editLead(param, success, error) {
    this.api.post('/crm/lead/edit', param,
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      });
  }

  getLeadList(param, success, error) {
    this.api.get('/crm/lead', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  leadToCustomer(param, success, error) {
    this.api.post('/crm/lead/leadToCustomer', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  createCustomer(param, success, error) {
    this.api.post('/crm/customer/create', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  editCustomer(param, success, error) {
    this.api.post('/crm/customer/edit', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getCustomerList(param, success, error) {
    this.api.get('/customer', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getCalendar(param, success, error) {
    this.api.get('/calendar', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getNotification(param,success,error){
    this.api.get('/notification', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
   notifyMessage(param, success, error) {
    this.api.post('/notification/notify', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
  getAppointment(param, success, error) {
    this.api.get('/appointment', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
  createAppointment(param, success, error) {
    this.api.post('/appointment/create', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
  editAppointment(param, success, error) {
    this.api.post('/appointment/edit', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
  deleteAppointment(param, success, error) {
    this.api.post('/appointment/delete', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/Crm/apiList.js